module.exports = __webpack_public_path__ + "static/img/a018.b2d888c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a018.jpg
// module id = dn2p
// module chunks = 0